module.exports = __webpack_public_path__ + "static/img/bloogApprentice.075b01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personagens/bloogApprentice.png
// module id = 660
// module chunks = 2 3 4 5 7 23 27